import Title from "@/components/ui/title/title";

const Premissas = () => (
  <section id="id" className="content-text">
    <Title type='h2' classX=" text-primary-emphasis">Premissas</Title>
    <p>
      Este manifesto tem o objetivo de propor mudanças e melhorias na infraestrutura de Transporte Público da cidade de Sabará e também à estrutura Metropolitana que atende aos sabarenses. Aqui, proporemos ampliação, reativação e criação de linhas, alteração de itinerários, integração entre os diferentes sistemas de Transporte Público e terminais de integração entre as linhas de ônibus da cidade, as linhas de ônibus de Belo Horizonte, o Move e trem.
    </p>
  </section>
);

export default Premissas;
